/* eslint-disable no-mixed-operators */
/* eslint-disable no-useless-concat */
import React, { useState } from "react";
import { read, utils, writeFile } from "xlsx";
import { useQuery } from "react-query";

import { getMembers } from "../../../api/apiServices";
import { useNavigate, useLocation } from "react-router-dom";
import Pagination from "../../../services/Pagination";
import toast, { Toaster } from "react-hot-toast";

const MembershipReports = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/membership_reports";

	const year = new Date().getFullYear() - 5;
	const years = Array.from(new Array(20), (val, index) => index + year);
	const curr = new Date();
	curr.setDate(curr.getDate());
	var date = curr.toISOString().substring(0, 10);

	const [isByDate, setIsByDate] = useState(false);
	const [isByMonth, setIsByMonth] = useState(false);
	const [isByOthers, setIsByOthers] = useState(true);

	const [membershipByDate, setMembershipByDate] = useState([]);
	const [membershipByMonth, setMembershipByMonth] = useState([]);

	const [searchByDate, setSearchByDate] = useState({
		begin_date: date,
		end_date: date,
	});

	const [searchByMonth, setSearchByMonth] = useState({
		regMonth: "",
		regYear: "",
	});

	const [state, setState] = useState({
		isAll: true,
		isMale: false,
		isFemale: false,
	});

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(25);

	const {
		isLoading,
		isError,
		error,
		data: membership,
	} = useQuery("membership", getMembers);

	let femaleData = [];
	let maleData = [];
	let allData = [];
	let byDate = [];
	let byMonth = [];

	let femaleCount = 0;
	let maleCount = 0;

	for (var i = 0; i < membership?.length; i++) {
		let femaleGender = membership[i].gender;
		if (femaleGender === "FEMALE") {
			femaleCount = femaleCount + 1;
			femaleData.push({
				serial_no: femaleCount,
				pf_number: membership[i].pf_number,
				full_name:
					membership[i].first_name +
					" " +
					membership[i].middle_name +
					" " +
					membership[i].last_name,
				region: membership[i].region,
				gender: membership[i].gender,
				date_joined: membership[i].date_joined,
				profession: membership[i].profession,
				current_employment: membership[i].current_employment,
				mobile_number: membership[i].mobile_number,
				email: membership[i].email,
			});
		}
	}

	for (var j = 0; j < membership?.length; j++) {
		let maleGender = membership[j].gender;
		if (maleGender === "MALE") {
			maleCount = maleCount + 1;
			let mData = {
				serial_no: maleCount,
				pf_number: membership[j].pf_number,
				full_name:
					membership[j].first_name +
					" " +
					membership[j].middle_name +
					" " +
					membership[j].last_name,
				region: membership[j].region,
				date_joined: membership[j].date_joined,
				gender: membership[j].gender,
				profession: membership[j].profession,
				current_employment: membership[j].current_employment,
				mobile_number: membership[j].mobile_number,
				email: membership[j].email,
			};
			maleData.push(mData);
		}
	}

	for (var k = 0; k < membership?.length; k++) {
		allData.push({
			serial_no: k + 1,
			pf_number: membership[k].pf_number,
			full_name:
				membership[k].first_name +
				" " +
				membership[k].middle_name +
				" " +
				membership[k].last_name,
			region: membership[k].region,
			gender: membership[k].gender,
			date_joined: membership[k].date_joined,
			profession: membership[k].profession,
			current_employment: membership[k].current_employment,
			mobile_number: membership[k].mobile_number,
			email: membership[k].email,
		});
	}

	let currentPosts = [];
	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;

	if (state.isFemale) {
		currentPosts = femaleData?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (state.isMale) {
		currentPosts = maleData?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (state.isAll) {
		currentPosts = membership?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (isByDate) {
		currentPosts = membershipByDate?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (isByMonth) {
		currentPosts = membershipByMonth?.slice(indexOfFirstPage, indexOfLastPage);
	}

	const handleByDate = () => {
		setIsByDate(true);
		setIsByMonth(false);
		setIsByOthers(false);
	};
	const handleByMonth = () => {
		setIsByDate(false);
		setIsByMonth(true);
		setIsByOthers(false);
	};

	const handleDateChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchByDate((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleMonthChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchByMonth((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleDateSearch = async (e) => {
		e.preventDefault();
		const name = "byDate"
			const beginDate = new Date(searchByDate.begin_date);
		const endDate = new Date(searchByDate.end_date);

		const byDateRecords = membership?.filter(
			(member) =>
				new Date(member.date_joined) >= beginDate &&
				new Date(member.date_joined) <= endDate
		);

		if (byDateRecords.length <= 0) {
			toast.success(
				`No record found for dates between  ${searchByDate.begin_date} and ${searchByDate.end_date} `,
				{
					duration: 5000,
					className: "toast-message",
				}
			);
		} else {
			setMembershipByDate(byDateRecords);
			for (var m = 0; m < byDateRecords?.length; m++) {
				byDate.push({
					serial_no: i + 1,
					pf_number: byDateRecords[m].pf_number,
					full_name:
						byDateRecords[m].first_name +
						" " +
						byDateRecords[m].middle_name +
						" " +
						byDateRecords[m].last_name,
					region: byDateRecords[m].region,
					gender: byDateRecords[m].gender,
					date_joined: byDateRecords[m].date_joined,
					profession: byDateRecords[m].profession,
					current_employment: byDateRecords[m].current_employment,
					mobile_number: byDateRecords[m].mobile_number,
					email: byDateRecords[m].email,
				});
			}
			handleExportExcel(name, byDate);
		}
	};

	const handleMonthSearch = async (e) => {
		e.preventDefault();
		const name = "byMonth"

		const beginDate = new Date(
			searchByMonth.regYear + "-" + searchByMonth.regMonth + "-" + "01"
		);
		const endDate = new Date(
			searchByMonth.regYear + "-" + searchByMonth.regMonth + "-" + "31"
		);

		const byMonthRecords = membership?.filter(
			(member) =>
				new Date(member.date_joined) >= beginDate &&
				new Date(member.date_joined) <= endDate
		);
		if (byMonthRecords.length <= 0) {
			toast.success(
				`No record found for the period ${
					searchByMonth.regYear + searchByMonth.regMonth
				} `,
				{
					duration: 5000,
					className: "toast-message",
				}
			);
		} else {
			setMembershipByMonth(byMonthRecords);
			for (var n = 0; n < byMonthRecords?.length; n++) {
				byMonth.push({
					serial_no: i + 1,
					pf_number: byMonthRecords[n].pf_number,
					full_name:
						byMonthRecords[n].first_name +
						" " +
						byMonthRecords[n].middle_name +
						" " +
						byMonthRecords[n].last_name,
					region: byMonthRecords[n].region,
					gender: byMonthRecords[n].gender,
					date_joined: byMonthRecords[n].date_joined,
					profession: byMonthRecords[n].profession,
					current_employment: byMonthRecords[n].current_employment,
					mobile_number: byMonthRecords[n].mobile_number,
					email: byMonthRecords[n].email,
				});
			}
			handleExportExcel(name, byMonth);
		}
	};

	

	const handleAll = () => {
		const name = "All";
		setState((prevData) => ({
			...prevData,
			isAll: true,
		}));
		handleExportExcel(name, allData);
	};
	const handleMale = () => {
		const name = "Male";
		setState((prevData) => ({
			...prevData,
			isMale: true,
		}));
		handleExportExcel(name, maleData);
	};
	const handleFemale = () => {
		const name = "Female";
		setState((prevData) => ({
			...prevData,
			isFemale: true,
		}));
		handleExportExcel(name, femaleData);
	};

	const handleExportExcel = (name, data) => {
		const headings = [
			[
				"SERIAL NO.",
				"PF NUMBER",
				"FULL NAME",
				"REGION",
				"GENDER",
				"DATE JOINED",
				"PROFESSION",
				"CURRENT EMPLOYMENT",
				"MOBILE NUMBER",
				"EMAIL ADDRESS",
			],
		];

		const wb = utils.book_new();
		const ws = utils.json_to_sheet([]);
		utils.sheet_add_aoa(ws, headings);
		let filename = "";

		if (name === "Female") {
			filename = "Female_Proforum_Membership.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		if (name === "Male") {
			filename = "Male_Proforum_Membership.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		if (name === "All") {
			filename = "All_Proforum_Membership.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		if (name === "byDate") {
			filename = "Date_Proforum_Membership.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		if (name === "byMonth") {
			filename = "Month_Proforum_Membership.xlsx";
			utils.sheet_add_json(ws, data, {
				origin: "A2",
				skipHeader: true,
			});
		}
		utils.book_append_sheet(wb, ws, "Report");
		writeFile(wb, filename);
		navigate(from, { replace: true });
	};

	const handleCancel = () => {
		setState({
			isAll: true,
			isMale: false,
			isFemale: false,
		});
		setIsByDate(false);
		setIsByMonth(false);
		setIsByOthers(true);
		navigate(from, { replace: true });
	};

	const dateSearch = (
		<>
			<form onSubmit={handleDateSearch}>
				<div className="form-group row">
					<label htmlFor="begin_date" className="col-sm-2 label-login">
						Begin Date
					</label>
					<div className="col-sm-3">
						<input
							type="date"
							id="begin_date"
							name="begin_date"
							style={{
								height: 40,
								fontSize: 18,
							}}
							value={searchByDate.begin_date}
							onChange={handleDateChange}
							required
							className="form-control"
						/>
					</div>
					<label htmlFor="end_date" className="col-sm-2 label-login">
						End Date
					</label>
					<div className="col-sm-3">
						<input
							type="date"
							id="end_date"
							name="end_date"
							style={{
								height: 40,
								fontSize: 18,
							}}
							value={searchByDate.end_date}
							onChange={handleDateChange}
							required
							className="form-control"
						/>
					</div>
					<div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Generate
						</button>
					</div>
				</div>
			</form>
		</>
	);

	const monthSearch = (
		<>
			<form onSubmit={handleMonthSearch}>
				<div className="form-group row">
					<label htmlFor="regYear" className="col-sm-2 label-login">
						Select Year
					</label>
					<div className="col-sm-3">
						<select
							type="text"
							id="regYear"
							autoComplete="off"
							style={{
								height: 40,
								fontSize: 18,
							}}
							name="regYear"
							value={searchByMonth.regYear}
							onChange={handleMonthChange}
							required
							className="form-control"
						>
							<option>Select Year</option>
							{years.map((year, index) => (
								<option value={year} key={`year${index}`}>
									{year}
								</option>
							))}
						</select>
					</div>

					<label htmlFor="regMonth" className="col-sm-2 label-login">
						End Date
					</label>
					<div className="col-sm-3">
						<select
							type="text"
							name="regMonth"
							id="regMonth"
							style={{
								height: 40,
								fontSize: 18,
							}}
							required
							onChange={handleMonthChange}
							value={searchByMonth.regMonth}
							className="form-control"
						>
							<option>Month</option>
							<option value="01">January - 01</option>
							<option value="02">February - 02</option>
							<option value="03">March - 03</option>
							<option value="04">April - 04</option>
							<option value="05">May - 05</option>
							<option value="06">June - 06</option>
							<option value="07">July - 07</option>
							<option value="08">August - 08</option>
							<option value="09">September - 09</option>
							<option value="10">October - 10</option>
							<option value="11">November - 11</option>
							<option value="12">December - 12</option>
						</select>
					</div>

					<div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Generate
						</button>
					</div>
				</div>
			</form>
		</>
	);

	
	const byDatecontent = (
			<div className="table-responsive lg table-wrapper">
				<table className="table table-bordered table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Region</th>
							<th scope="col">Gender</th>
							<th scope="col">Date Joined</th>
							<th scope="col">Profession</th>
							<th scope="col">Current Employment</th>
							<th scope="col">Mobile Number</th>
							<th scope="col">Email</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((member, index) => (
							<tr key={member.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{member.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.first_name +
										" " +
										member.middle_name +
										" " +
										member.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.region}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.gender}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.date_joined}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.profession}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.current_employment}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.mobile_number}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.email}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);

	const byMonthcontent = (
			<div className="table-responsive lg table-wrapper">
				<table className="table table-bordered table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Region</th>
							<th scope="col">Gender</th>
							<th scope="col">Date Joined</th>
							<th scope="col">Profession</th>
							<th scope="col">Current Employment</th>
							<th scope="col">Mobile Number</th>
							<th scope="col">Email</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((member, index) => (
							<tr key={member.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{member.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.first_name +
										" " +
										member.middle_name +
										" " +
										member.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.region}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.gender}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.date_joined}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.profession}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.current_employment}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.mobile_number}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.email}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	

	let content;
	if (isLoading) {
		content = (
			<tr>
				<td>Loading...</td>
			</tr>
		);
	} else if (isError) {
		content = (
			<tr>
				<td>{error.message}</td>
			</tr>
		);
	} else {
		content = (
			<div className="table-responsive lg table-wrapper">
				<table className="table table-bordered table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Region</th>
							<th scope="col">Gender</th>
							<th scope="col">Date Joined</th>
							<th scope="col">Profession</th>
							<th scope="col">Current Employment</th>
							<th scope="col">Mobile Number</th>
							<th scope="col">Email</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((member, index) => (
							<tr key={member.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{member.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.first_name +
										" " +
										member.middle_name +
										" " +
										member.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.region}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.gender}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.date_joined}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.profession}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.current_employment}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.mobile_number}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{member.email}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Membership Reports</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						GENERATE EXCEL FILES
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-4">
										<h4 className="panel-title">
											<button
												type="button"
												onClick={handleAll}
												className="btn btn-success btn-block"
											>
												<i
													className="fa fa-file-text"
													aria-hidden="true"
												></i>{" "}
												Excel File (ALL MEMBERS)
											</button>
											&nbsp; &nbsp;
										</h4>
									</div>
									<div className="col-sm-4">
										<h4 className="panel-title">
											<button
												type="button"
												onClick={handleMale}
												className="btn btn-success btn-block"
											>
												<i
													className="fa fa-file-text"
													aria-hidden="true"
												></i>{" "}
												Excel File (MALE)
											</button>
											&nbsp; &nbsp;
										</h4>
									</div>
									<div className="col-sm-4">
										<h4 className="panel-title">
											<button
												type="button"
												onClick={handleFemale}
												className="btn btn-success btn-block"
											>
												<i
													className="fa fa-file-text"
													aria-hidden="true"
												></i>{" "}
												Excel File (FEMALE)
											</button>
											&nbsp; &nbsp;
										</h4>
									</div>
									<div className="col-sm-4">
										<h4 className="panel-title">
											<button
												type="button"
												onClick={handleByDate}
												className="btn btn-success btn-block"
											>
												<i
													className="fa fa-file-text"
													aria-hidden="true"
												></i>{" "}
												Excel File (BY DATE)
											</button>
											&nbsp; &nbsp;
										</h4>
									</div>
									<div className="col-sm-4">
										<h4 className="panel-title">
											<button
												type="button"
												onClick={handleByMonth}
												className="btn btn-success btn-block"
											>
												<i
													className="fa fa-file-text"
													aria-hidden="true"
												></i>{" "}
												Excel File (BY MONTH)
											</button>
											&nbsp; &nbsp;
										</h4>
									</div>
									<div className="col-sm-4">
										<button className="btn btn-success btn-block">
											<i className="fa fa-file"></i>{" "}
											Generate PDF Report
										</button>
									</div>
								</div>
							</div>

							<div className="panel-heading">
								<div className="row">
									{isByDate && (
										<div className="panel-body">
											{dateSearch}
										</div>
									)}
									{isByMonth && (
										<div className="panel-body">
											{monthSearch}
										</div>
									)}
								</div>
							</div>
							{isByDate && membershipByDate.length >0 && (
								<div className="panel-body">
									{byDatecontent}
								</div>
							)}

							{isByMonth && membershipByMonth.length>0 && (
								<div className="panel-body">
									{byMonthcontent}
								</div>
							)}

							{isByOthers && (
								<div className="panel-body">{content}</div>
							)}

							<div className="panel-footer">
								{isByOthers && membership?.length > 0 ? (
									<Pagination
										data={membership}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								) : isByDate && membershipByDate?.length > 0 ? (
									<>
										<Pagination
											data={membershipByDate}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
										<div className="search-group">
											<button
												type="button"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</>
								) : isByMonth &&
								  membershipByMonth?.length > 0 ? (
									<>
										<Pagination
											data={membershipByMonth}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
										<div className="search-group">
											<button
												type="button"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default MembershipReports;
